import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowDoubleLeft = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 19,
	height: 20,
	viewBox: "0 0 19 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_272_9)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M9.61084 10.1919L9.60889 10.1909L9.60986 10.1899L9.60889 10.189H9.61084L14.1128 1.15674H18.6089L14.1567 10.188L18.5923 19.1567H14.1167L9.61084 10.1919Z",
			fill: "#001E50"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M0.61084 10.0059L0.608887 10.0049L0.609863 10.0039L0.608887 10.0029H0.61084L5.11279 0.970704L9.60889 0.970703L5.15674 10.002L9.59229 18.9707H5.1167L0.61084 10.0059Z",
			fill: "#001E50"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_272_9",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 19,
			height: 20,
			fill: "white"
		})
	}) })]
});
export default SvgArrowDoubleLeft;
